/**
 * Computes updated text by stripping an old topic prefix and prepending a new one.
 *
 * Pattern: "Topics: A, B. <user text>" → "Topics: C. <user text>"
 */
export function buildTopicUpdatedText(
  oldTopics: string[],
  newTopics: string[],
  currentText: string,
): string {
  const oldPrefix =
    oldTopics.length > 0 ? `Topics: ${oldTopics.join(', ')}` : '';
  const newPrefix =
    newTopics.length > 0 ? `Topics: ${newTopics.join(', ')}` : '';

  let userText = currentText;
  if (oldPrefix && userText.startsWith(oldPrefix)) {
    userText = userText.slice(oldPrefix.length).replace(/^\.?\s*/, '');
  }

  if (!newPrefix) return userText;
  return userText ? `${newPrefix}. ${userText}` : newPrefix;
}
